
import React from 'react';

interface GalleryIndicatorsProps {
  count: number;
  currentIndex: number;
  onSelect: (index: number) => void;
  size?: 'default' | 'large';
}

const GalleryIndicators = ({ 
  count, 
  currentIndex, 
  onSelect,
  size = 'default'
}: GalleryIndicatorsProps) => {
  if (count <= 1) return null;
  
  const dotSize = size === 'large' ? 'w-2.5 h-2.5' : 'w-2 h-2';
  
  return (
    <div className="absolute bottom-2 left-0 right-0 flex justify-center gap-1 z-10">
      {Array.from({ length: count }).map((_, index) => (
        <button
          key={index}
          onClick={() => onSelect(index)}
          className={`${dotSize} rounded-full ${currentIndex === index ? 'bg-white' : 'bg-white/50'}`}
          aria-label={`Go to image ${index + 1}`}
        />
      ))}
    </div>
  );
};

export default GalleryIndicators;
